var map = {
	"./apple_airpods.png": 659,
	"./apple_watch.png": 660,
	"./certificate_for_stationery.png": 661,
	"./game_mouse.png": 662,
	"./headset.png": 663,
	"./humidifier.png": 664,
	"./mechanical_keyboard.png": 665,
	"./pizza.png": 666,
	"./power_bank.png": 667,
	"./smart_speaker.png": 668,
	"./three_pizzas.png": 669,
	"./usb_mug.png": 670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 177;